import categories from './categories.json';
import home from './home.json';
import address from './address.json';
import store from './store.json';
import common from './common.json';
import messageRequest from './message-request.json';
import payment from './payment.json';
import panther from './panther.json';
import promotion from './promotion.json';
import event from './event.json';
import alert from './alert.json';

export default {
  categories,
  home,
  address,
  store,
  common,
  messageRequest,
  payment,
  panther,
  promotion,
  event,
  alert,
};
